import { render, staticRenderFns } from "./ContactInfoModal.vue?vue&type=template&id=005ac3bd&scoped=true"
import script from "./ContactInfoModal.vue?vue&type=script&lang=ts"
export * from "./ContactInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ac3bd",
  null
  
)

export default component.exports